import React from "react";
import moment from "moment";
import { Dropdown } from "react-bootstrap";
import APIComponent from "../../components/API";
import core from "../../vendors/core-api";
import { useParams, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import TitleHelmet from "../../partials/TitleHelmet";
import AnalyticsGrid from "../../components/dashboard/AnalyticsGrid";
import GroupDropdown from "../../components/dashboard/GroupDropdown";
import { DB_DATE_FORMAT, DATERANGE_LIST } from "../../constants";
import DateRangeDropdown from "../../components/dashboard/DateRangeDropdown";
import SourceFilterDropdown from "../../components/dashboard/SourceFilterDropdown";
import PacmanWrapper from "../../components/dashboard/PacmanWrapper";

export default function Page() {
  const { brand_url = "" } = useParams(),
    { user } = useSelector((state) => state.auth);
  return <MainComponent id={brand_url} user={user} role={user.iam_role} />;
}

class MainComponent extends APIComponent {
  constructor(props) {
    super(props);

    this.state = {
      showSplashScreen: false,
      redirectTo: "",
      title: "Analytics",
      date: moment().format(DB_DATE_FORMAT),
      selectedBrand: {},
      source_options: [],
      source_filter: "all",
    };

    this.api = core("pu").get();
    this.data_url = `/brand/u/${props.id}/analytics`;

    this.handleDateRangeClick.bind(this);
  }

  async componentDidUpdate(_, prevState) {
    if (this.state.source_filter !== prevState.source_filter) {
      await this.getData();
    }
  }

  handleDateRangeClick = async (
    e,
    date = moment().format(DB_DATE_FORMAT),
    name,
    rangeValue,
    endDate,
  ) => {
    let statCardDataRange = "";
    const dropdownText = e?.currentTarget?.textContent || name || "day";

    if (
      dropdownText === "Date Range" ||
      dropdownText === "Custom Range" ||
      rangeValue === "between"
    ) {
      statCardDataRange = "between";
    } else if (
      dropdownText === "This Week" ||
      dropdownText === "Last Week" ||
      dropdownText === "Next Week"
    ) {
      statCardDataRange = "week";
    } else if (dropdownText === "This Month" || dropdownText === "Last Month") {
      statCardDataRange = "month";
    } else if (dropdownText === "This Year" || dropdownText === "Last Year") {
      statCardDataRange = "year";
    } else if (dropdownText === "All-time") {
      statCardDataRange = "allTime";
    } else {
      statCardDataRange = "day";
    }

    const selectedStartDate =
      date || this.state.date || moment().format(DB_DATE_FORMAT);
    const selectedEndDate = endDate || this.state.endDate || selectedStartDate;

    this.setState({
      statCardQuery: statCardDataRange,
      date: selectedStartDate,
      endDate: statCardDataRange === "between" ? selectedEndDate : undefined,
      data_status: "fetching",
    });
    setTimeout(() => {
      this.getData();
    }, 500);
  };

  handleChangeSelectedStore = async (item) => {
    this.setState({
      selectedBrand: item,
      data_status: "fetching",
    });
    setTimeout(() => {
      this.getData();
    }, 500);
  };

  groupSourceData = (data) => {
    let group_data = [];
    for (const source of data) {
      if (source.includes("fbclid")) {
        group_data.push("https://facebook.com");
      } else if (
        source.includes("pickup.ph") ||
        source === "" ||
        source === "null"
      ) {
        group_data.push("pickup.ph");
      } else if (source.includes("localhost")) {
        group_data.push("http://localhost:3000");
      } else {
        group_data.push(source);
      }
    }
    return group_data;
  };

  async getData() {
    const { role = "", brands = [] } = this.props;
    this._isMounted && this.setState({ data_status: "fetching" });
    let date = this.state.date || moment().format(DB_DATE_FORMAT);
    let endDate = this.state.endDate;
    let statCardRange = this.state.statCardQuery || "day";
    let view = this.state.selectedBrand || { id: "", name: "All" };

    const getSourceContent = async () => {
      const { data } = await new Promise((resolve, reject) => {
        this.api
          .post({
            url: "/dashboard/sales-by-referrer/type",
            data: {
              date: "2024-01-01",
              brands,
              role,
              dateRange: "year",
              id: this.state.selectedBrand.id || "",
              attr: this.state.selectedBrand.attr || "brand",
            },
          })
          .then((data) => resolve(data.data))
          .catch((err) => reject(err));
      });

      const options = data.map((analytics) => analytics._id).filter(Boolean);

      return ["All", ...new Set(this.groupSourceData(options))];
    };

    const getContent = () => {
      const endDateParam =
        statCardRange === "between" && endDate ? `&endDate=${endDate}` : "";
      return new Promise((resolve, reject) => {
        this.api
          .get(
            `/brand/u/${this.props.id}/analytics?dateRange=${statCardRange}&date=${date}&view=${view.id}${endDateParam}`,
          )
          .then((data) => resolve(data.data))
          .catch((err) => reject(err));
      });
    };

    try {
      const content = await getContent();
      const source_options = await getSourceContent();
      const defaultAttr = this.props.role === "store_admin" ? "store" : "brand";
      const defaultSelectedBrand = {
        ...content.allStores[0],
        attr: defaultAttr,
        id: ["store_admin", "console_user"].includes(this.props.role)
          ? this.props.stores[0]
          : "",
      };

      this._isMounted &&
        this.setState({
          data: {
            ...content,
          },
          selectedBrand:
            this.state.selectedBrand &&
            (this.state.selectedBrand.id || this.state.selectedBrand.name)
              ? this.state.selectedBrand
              : defaultSelectedBrand,
          data_status: "fetched",
          order_fetch_status: "fetched",
          source_options,
        });

      this.handleOnDataFetched();
      if (this.use_display_data) {
        this.setDisplayData();
      }
    } catch (error) {
      this._isMounted && this.setState({ error: error, showSwalError: true });
      this.handleOnDataFetchError();
    }
  }
  render() {
    const {
      user: { brands = [] },
      role = "",
    } = this.props;
    const brandId = this.props.id;
    const {
        data = {},
        data_status = "",
        selectedBrand = {},
        statCardQuery = "day",
        date = moment().format(DB_DATE_FORMAT),
        endDate,
      } = this.state,
      isLoading = data_status !== "fetched";
    const { allStores = [] } = data;
    const { id = "", attr = "" } = selectedBrand;
    const params = {
      date,
      ...(statCardQuery === "between" && endDate ? { endDate } : {}),
      brands,
      role,
      dateRange: statCardQuery,
      id: selectedBrand.id || "",
      attr: selectedBrand.attr || "brand",
      source_filter: "all",
    };

    function dropdownText(dateRange, date) {
      if (dateRange === "between") return "Custom Range";

      const isCurrent = moment(moment().format(DB_DATE_FORMAT)).isSame(
        date,
        dateRange,
      );

      const prefix = isCurrent ? "This" : "Last";

      // if(dateRange=== 'week') return `${prefix} Week`
      if (dateRange === "week") {
        if (
          moment(moment().add(1, "weeks").format(DB_DATE_FORMAT)).isSame(date)
        ) {
          return "Next Week";
        }

        return `${prefix} Week`;
      }
      if (dateRange === "month") return `${prefix} Month`;
      if (dateRange === "year") return `${prefix} Year`;
      if (dateRange === "allTime") return "All-time";
      return `${isCurrent ? "Today" : "Yesterday"}`;
    }

    return (
      <>
        <TitleHelmet title={this.state.title} />

        {this.state.showSplashScreen ? <LayoutSplashScreen /> : <></>}

        {this.state.redirectTo !== "" ? (
          <Redirect to={this.state.redirectTo} />
        ) : (
          <></>
        )}

        {/* <HeaderTextWithActions title={this.state.title} /> */}

        {isLoading ? (
          <>
            <div className="d-flex justify-content-center align-items-center h-100">
              <PacmanWrapper removeBackgroundColor />
            </div>
          </>
        ) : (
          <div>
            <div className="d-flex justify-content-space-between mb-4">
              <div className="d-flex align-items-center ">
                <span className="pr-2 text-center font-weight-bold mr-4">
                  Filter by Source:
                </span>
                <SourceFilterDropdown
                  options={this.state.source_options}
                  selectedValue={this.state.source_filter}
                  onSelect={(value) =>
                    this.setState({ source_filter: value.toLowerCase() })
                  }
                  className="align-self-end rounded-top"
                />
              </div>
              <div className="d-flex justify-content-end">
                <GroupDropdown
                  items={allStores}
                  className={"mr-2"}
                  hasRollup={false}
                  onSelectView={this.handleChangeSelectedStore}
                  selectedView={
                    selectedBrand.name ? selectedBrand : allStores[0]
                  }
                  attr={"brand"}
                />

                <DateRangeDropdown
                  onDateRangeSelect={this.handleDateRangeClick}
                  statCardText={dropdownText(statCardQuery, date)}
                  selectedDate={date}
                  startDate={date}
                  endDate={endDate}
                  selectedRange={statCardQuery}
                  className="ml-4 align-self-end rounded-top"
                />
              </div>
            </div>

            <AnalyticsGrid
              itemSoldURL={`/brand/u/${brandId}/analytics/item-sold?dateRange=${statCardQuery}&date=${date}&id=${id}&attr=${attr}${
                statCardQuery === "between" && endDate
                  ? `&endDate=${endDate}`
                  : ""
              }`}
              selectedBrand={selectedBrand}
              data={data}
              statCardQuery={statCardQuery}
              date={date}
              endDate={endDate}
              params={params}
              brand_url={brandId}
              isMulti={false}
              api={this.api}
            />
          </div>
        )}
      </>
    );
  }
}
